// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const fa = {
    demo: {
      title: `Farsi`,
      introduction: `معرفی سامانه الکترونیک مدیریت توزیع کالا`,
    },
    docs: {
      hi: `با سلام`,
      description: `در صورت نیاز به راهنمایی ، مستندات را مطالعه نمایید.`,
      documentation: `مستندات`,
    },
    home: `خانه`,
    app: `سامانه`,
    user: `کاربر`,
    list: `لیست`,
    edit: `ویرایش`,
    shop: `فروشگاخ`,
    blog: `وبلاگ`,
    post: `پست`,
    mail: `ایمیل`,
    chat: `گفتگو`,
    cards: `سید`,
    posts: `posts`,
    create: `ایجاد`,
    kanban: `kanban`,
    general: `عمومی`,
    banking: `بانکداری`,
    booking: `رزرو`,
    profile: `مشخصات`,
    account: `حساب`,
    product: `محصول`,
    invoice: `فاکتور`,
    details: `جزئیات`,
    checkout: `تسویه حساب`,
    calendar: `تقویم`,
    analytics: `تجزیه و تحلیل`,
    ecommerce: `تجارت الکترونیک`,
    management: `مدیریت`,
    menu_level: `سطح منو`,
    menu_level_2a: `menu level 2a`,
    menu_level_2b: `menu level 2b`,
    menu_level_3a: `menu level 3a`,
    menu_level_3b: `menu level 3b`,
    menu_level_4a: `menu level 4a`,
    menu_level_4b: `menu level 4b`,
    item_disabled: `item disabled`,
    item_label: `item label`,
    item_caption: `item caption`,
    item_external_link: `item external link`,
    description: `description`,
    other_cases: `other cases`,
    item_by_roles: `item by roles`,
    only_admin_can_see_this_item: `فقط مدیر اجازه دسترسی دارد`,
  };
  
  export default fa;
  